<template>
	<div class="mod-device" v-loading="contLoading" element-loading-text="数据加载中">
		<div class="basicInfo">
			<div class="goodsImg">
				<img :src="goodsImgUrl" alt="" />
			</div>
			<div class="info">
				<h3 class="goodsName">{{ goodsInfo.goodsName }}</h3>
				<div class="itembox">
					<el-row class="info_item">
						<el-col :span="12" class="ellipsis" :title="goodsInfo.manufacturer"><span class="lablekey">制造厂商：</span>{{ goodsInfo.manufacturer }}</el-col>
						<el-col :span="12" class="ellipsis"><span class="lablekey">规格型号：</span>{{ goodsInfo.specModel }}</el-col>
					</el-row>
					<el-row class="info_item">
						<el-col :span="12" class="ellipsis" :title="goodsInfo.gxtionType"><span class="lablekey">仪器分类：</span>{{ goodsInfo.gxtionType }}</el-col>
						<el-col :span="12" class="ellipsis" :title="goodsInfo.cationType"><span class="lablekey">功能分类：</span>{{ goodsInfo.cationType }}</el-col>
					</el-row>
					<el-row class="info_item">
						<el-col :span="12" class="ellipsis"><span class="lablekey">设备管理员：</span>{{ goodsInfo.deviceAdmin }}</el-col>
						<el-col :span="12" class="ellipsis"><span class="lablekey">联系方式：</span>{{ goodsInfo.wechat }}</el-col>
					</el-row>
					<el-row class="info_item">
						<el-col :span="24" class="ellipsis"><span class="lablekey">所在位置：</span>{{ goodsInfo.location }}</el-col>
					</el-row>
				</div>
				<p class="hours">
					<!-- 平均<span class="h_h">{{ goodsInfo.workHours }}</span
					>个工作日完成 -->
				</p>
				<div class="btnbox">
					<el-button
						round
						size="small"
						:type="btn.code == 'INSTRUMENT_APP' ? 'primary' : ''"
						v-for="(btn, index) of goodsInfo.businessTypeList"
						:key="index"
						@click="orderHandle(btn.code, goodsInfo)"
						>{{ btn.val }}</el-button
					>
				</div>
			</div>
		</div>
		<div class="otherInfo">
			<div class="tab-list">
				<span class="tab-item" :class="currentTabIndex == index ? 'active' : ''" @click="tabChangeHandle(index)" v-for="(item, index) of tabs" :key="index">{{ item }}</span>
			</div>
			<div class="tabBody">
				<div class="diyinfo" v-if="currentTabIndex == 0">
					<div class="replenish" v-for="(rep, index) of replenishList" :key="index">
						<h3 class="dtitle">{{ rep.title }}</h3>
						<div class="repContent" v-html="rep.content"></div>
					</div>
				</div>
				<div class="prjItems" v-if="currentTabIndex == 1">
					<el-table :data="itemData" max-height="500">
						<el-table-column type="index" label="序号" width="50"> </el-table-column>
						<el-table-column prop="tiName" label="检测项目" show-overflow-tooltip />
						<el-table-column prop="funStdName" label="检测标准" show-overflow-tooltip></el-table-column>
						<el-table-column prop="funStdCode" label="标准代号"></el-table-column>
					</el-table>
				</div>
			</div>
		</div>
		<!-- 预约面板 -->
		<timepanel v-if="timeVisible" ref="timepanel" @createOrder="createOrder"></timepanel>
	</div>
</template>

<script>
import Timepanel from './../common/Timepanel.vue'
export default {
	components: {
		Timepanel,
	},
	data() {
		return {
			contLoading: true, // 全局加载
			pageUrl: '',
			pageTitle: '',
			prn: '',
			tabs: ['设备信息', '检测项目'],
			currentTabIndex: 0,
			goodsImgUrl: '',
			goodsInfo: {},
			replenishList: [],
			itemData: [],
			timeVisible: false,
		}
	},
	computed: {
		fileUploadUrl() {
			return window.SITE_CONFIG.fileUpload
		},
		filePreview() {
			return window.SITE_CONFIG.previewFile
		},
		loginVisible: {
			get() {
				return this.$store.state.loginVisible
			},
			set(val) {
				this.$store.commit('updateLoginVisible', val)
			},
		},
	},
	created() {
		this.pageUrl = this.$route.name
		this.pageTitle = this.$route.meta.title
		this.prn = this.$route.query.prn || ''
		this.init()
	},

	methods: {
		init() {
			this.getGoodsInfo()
			this.getItemList()
		},
		// 产品信息
		getGoodsInfo() {
			this.$http
				.get(this.$api.goodsApi.goodsInfo, { params: { goodsPrn: this.prn } })
				.then(({ data }) => {
					let obj = data.data
					this.goodsImgUrl = obj['goodsImage'].length > 0 ? this.filePreview + obj['goodsImage'][0] : ''
					this.goodsInfo = { ...this.goodsInfo, ...obj }
					this.replenishList = obj['details'] ? obj['details'] : []
					this.contLoading = false
				})
				.catch(() => {
					this.contLoading = false
				})
		},
		// 检项列表
		getItemList() {
			let params = {
				current: '1',
				size: '100000',
				data: {
					prodPrn: this.prn,
				},
			}
			this.$http.post(this.$api.goodsApi.itemLimisList, params).then(({ data }) => {
				this.itemData = data.data.list
			})
		},
		// tabChangeHandle
		tabChangeHandle(index) {
			this.currentTabIndex = index
		},
		// 选择下单
		orderHandle(orderType, goods) {
			let token = this.$cookie.get('X-Web-Token')
			if (!token) {
				console.log(this.$refs)
				this.loginVisible = true
			} else {
				this.$confirm(goods.prompt, {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					customClass: 'orderTips',
					type: 'warning',
				})
					.then(() => {
						switch (orderType) {
							//委托检测
							case 'ENTRUST_DETN':
								this.createOrder({
									goodsPrn: goods.prn,
									orderType: orderType,
								})
								break
							//SANS检测
							case 'CNAS_DETN':
								this.createOrder({
									goodsPrn: goods.prn,
									orderType: orderType,
								})
								break
							//自主上机
							case 'AUTONOMY_APP':
								this.reservationHandle(goods.prn, orderType)
								break
							//仪器预约
							case 'INSTRUMENT_APP':
								this.reservationHandle(goods.prn, orderType)
								break
							default:
								break
						}
					})
					.catch(() => {})
			}
		},
		// 创建订单
		createOrder(params) {
			this.$http.post(this.$api.orderApi.orderAdd, params).then(({ data }) => {
				console.log(data)
				this.$router.push({ name: 'order', query: { type: params.orderType, orderId: data.data, title: this.pageTitle, from: this.pageUrl } })
			})
		},
		// 预约
		reservationHandle(prn, orderType) {
			console.log(prn, orderType)
			this.timeVisible = true
			this.$nextTick(() => {
				this.$refs.timepanel.init(prn, orderType, '', this.pageTitle, this.pageUrl)
			})
		},
	},
}
</script>

<style lang="scss" scoped>
.mod-device {
	.basicInfo {
		display: flex;
		margin-bottom: 35px;
		.goodsImg {
			width: 320px;
			height: 230px;
			overflow: hidden;
			img {
				width: 300px;
			}
		}
		.info {
			flex: 1;
			h3 {
				margin-top: 0;
			}
			.itembox {
				padding: 10px 16px;
				background: #f7f7f7;
				border-radius: 8px;
			}
			.info_item {
				line-height: 26px;
				user-select: none;
				.lablekey {
					color: #666;
				}
			}
			.hours {
				margin: 10px 0;
				height: 16px;
				.h_h {
					color: #2962b0;
				}
			}
		}
	}
	.otherInfo {
		.tab-list {
			font-size: 14px;
			border-bottom: 1px solid #f2f2f2;
			.tab-item {
				display: inline-block;
				background: #f5f7fa;
				margin-right: 10px;
				height: 38px;
				line-height: 38px;
				padding: 0 20px;
				border-radius: 8px 8px 0px 0px;
				cursor: pointer;
				&.active {
					background-color: #2962b0;
					color: #fff;
				}
			}
		}
	}
}
</style>
